<!--
 * @Author: wh
 * @Date: 2020-07-10 11:13:52
 * @LastEditTime: 2023-01-18 22:25:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\accountConfirm\accountConfirmInfo.vue
-->
<template>
    <div class="commonFormStyles accountConfirmInfo">
        <van-nav-bar
            title="账务记录详情"
            left-text="账务列表"
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <section class="van-pull-refresh">
            <van-cell-group>
                <van-cell
                    title="合同编号"
                    :value="formData.contract_number"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                ></van-cell>
                <van-cell
                    title="收款编号"
                    :value="formData.proceeds_number"
                    :icon="require('@/assets/images/icons/icon_32.png')"
                ></van-cell>
                <van-cell
                    title="客户名称"
                    :value="formData.client_name"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                ></van-cell>
                <van-cell
                    title="工程名称"
                    :value="formData.engineering_name"
                    :icon="require('@/assets/images/icons/icon_2.png')"
                ></van-cell>
                <van-cell
                    title="收款方式"
                    :value="formData.proceeds_mode_name"
                    :icon="require('@/assets/images/icons/icon_20.png')"
                ></van-cell>
                <van-cell
                    title="票据号"
                    :value="formData.bill_number"
                    :icon="require('@/assets/images/icons/icon_33.png')"
                ></van-cell>
                <van-cell
                    title="对方单位名称"
                    :value="formData.corp_name"
                    :icon="require('@/assets/images/icons/icon_gy_5.png')"
                ></van-cell>
                <van-cell
                    title="对方账号"
                    :value="formData.bank_account"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                ></van-cell>
                <van-cell
                    title="我方单位名称"
                    :value="formData.make_invoice_corp"
                    :icon="require('@/assets/images/icons/icon_gy_5.png')"
                ></van-cell>
                <van-cell
                    title="我方账号"
                    :value="formData.make_invoice_account"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                ></van-cell>
                <van-cell
                    title="结算单号"
                    :value="formData.settlement_number"
                    :icon="require('@/assets/images/icons/icon_18.png')"
                ></van-cell>
                <van-cell
                    title="对账日期"
                    :value="formData.reconciliation_date"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="结算周期开始时间"
                    :value="formData.settlement_start_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="结算周期结束时间"
                    :value="formData.settlement_end_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="实收金额"
                    :value="formData.official_receipt"
                    :icon="require('@/assets/images/icons/icon_26.png')"
                ></van-cell>
                <van-cell
                    title="收款日期"
                    :value="formData.receipt_date"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="期初应收"
                    :value="formData.Initial_receivables"
                    :icon="require('@/assets/images/icons/icon_20.png')"
                ></van-cell>
                <van-cell
                    title="本期应收"
                    :value="formData.loans_receivable"
                    :icon="require('@/assets/images/icons/icon_20.png')"
                ></van-cell>
                <van-cell
                    title="期末应收"
                    :value="formData.ending_receivable"
                    :icon="require('@/assets/images/icons/icon_20.png')"
                ></van-cell>
                <van-cell
                    title="期末应收余额"
                    :value="formData.ending_balance_receivable"
                    :icon="require('@/assets/images/icons/icon_26.png')"
                ></van-cell>
                <van-cell
                    title="业务员"
                    :value="formData.salesman_name"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                ></van-cell>
                <van-cell
                    title="业务员电话"
                    :value="formData.salesman_phone"
                    :icon="require('@/assets/images/icons/icon_4.png')"
                ></van-cell>
                <van-cell
                    title="收款状态"
                    :value="formData.proceeds_status"
                    :icon="require('@/assets/images/icons/icon_gy_10.png')"
                ></van-cell>
            </van-cell-group>
        </section>
        <div class="btn-con" v-if="formData.approval_status===0||formData.approval_status===1">
            <div class="submit-btn" @click="backProceeds(formData.apid)">
                退回
            </div>
            <div class="save-btn" @click="sureCallBack">
                确认
            </div>
        </div>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: 'over-contract-info',
    components: {},
    props: {},
    data() {
        return {
            // 表单数据
            formData: {},
            // id
            apid: '',
            // 加载层
            showOverlay: false,
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取收款详情
        getRetailDetail() {
            this.showOverlay = true;
            this.$axios
                .get('/interfaceApi/sale/accounts/get_accounts_proceeds?apid=' + this.apid)
                .then(res => {
                    if (res) {
                        if (res.proceeds_status === 1) {
                            res.proceeds_status = '未收款';
                        } else if (res.proceeds_status === 2) {
                            res.proceeds_status = '已收款';
                        } else if (res.proceeds_status === 4) {
                            res.proceeds_status = '已退回';
                        }
                        this.formData = res;
                        this.showOverlay = false;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                    this.showOverlay = false;
                });
        },
        // 收款确认
        sureCallBack() {
            this.showOverlay = true;
            this.$axios
                .post(`/interfaceApi/sale/accounts/proceeds/check_complete/${this.formData.apid}`)
                .then(resPre => {
                    if (resPre) {
                        this.$dialog.confirm({
                            title: '提示',
                            message: resPre,
                        })
                            .then(() => {
                                this.confirmProceedsOver();
                            })
                            .catch(() => {
                                this.showOverlay = false;
                            });
                    } else {
                        this.confirmProceedsOver();
                    }
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 收款确认完成
        confirmProceedsOver() {
            this.$axios
                .post('/interfaceApi/sale/accounts/proceeds/complete/' + this.formData.apid)
                .then(res => {
                    if (res) {
                        this.$toast('确认完成！');
                        this.getRetailDetail();
                        this.$route.params.data.approval_status_name = '已确认';
                    }
                    this.showOverlay = false;
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 退回
        backProceeds(pkvalue) {
            this.$axios.post(`/interfaceApi/sale/accounts/proceeds/back/${pkvalue}`).then(res => {
                if (res) {
                    this.$toast('退回成功！');
                    this.getRetailDetail();
                    this.$route.params.data.approval_status_name = '已退回';
                }
                this.showOverlay = false;
            }).catch(error => {
                this.showOverlay = false;
                this.$toast(error.ErrorCode.Message);
            });
        },
    },
    created() {
        this.apid = this.$route.params.data.apid;
        this.getRetailDetail();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.accountConfirmInfo
    .sureCallBack
        color #fff
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow-y auto
        padding-bottom 40rpx
        .trans-types
            padding-left 30rpx
            .van-field__control--custom
                display block
                .van-radio-group
                    margin-bottom 10rpx
            .custom-row
                margin-bottom 10rpx
                input
                    width 100rpx
                    border 0
                    border-bottom 1px solid #ccc
                    margin 0 10rpx
            .credit-limit
                margin 10rpx 0
                display flex
                span
                    margin-right 15rpx
    .btn-con
        display flex
        border-top 2px solid #D60110
        position absolute
        width 100%
        height 39rpx
        bottom 0
        z-index 1000
        background #fff
        div
            flex 1
            height 39rpx
            text-align center
            line-height 39rpx
            cursor pointer
        .submit-btn
            background #D60110
            color #fff
        .save-btn
            color #D60110
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
</style>
